import { array, boolean, defineAction, enumerated, expression, number, object } from '~/prix'
import { questionnaireObject } from '../questionnaireObject'
import questionnaireListAction from './questionnaireList.action.json'
import { z } from 'zod'

export const questionnaireExpression = expression(questionnaireObject.shape)

const questionnaireListDefinition = defineAction({
  ...questionnaireListAction,
  input: z.object({
    filter: questionnaireExpression.nullish(),
    limit: z.coerce.number().nullish(),
    offset: z.coerce.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      title: 'Título',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.coerce.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(
      questionnaireObject.omit({
        questions: true,
      }),
    ),
    count: z.number(),
  }),
})

export default questionnaireListDefinition
